export type LiveConfigurationPrice = { totalLabel: string; subLabel: string };

/** Display only the confirmed event for this product; never reuse another page's price. */
export function readLiveConfigurationPrice(detail: unknown, productId: string): LiveConfigurationPrice | null {
  if (!detail || typeof detail !== 'object') return null;
  const value = detail as Record<string, unknown>;
  if (value.productId !== productId || value.ready !== true ||
      typeof value.total !== 'number' || !Number.isFinite(value.total) || value.total <= 0 ||
      typeof value.totalLabel !== 'string' || !value.totalLabel) return null;
  return { totalLabel: value.totalLabel, subLabel: typeof value.subLabel === 'string' ? value.subLabel : '' };
}
